/* tslint:disable */
import {
  QualityMeasureValue
} from '../index';

declare var Object: any;
export interface QualityMeasureInterface {
  "id"?: number;
  "name"?: string;
  "value_ids"?: Array<any>;
  valueIds?: QualityMeasureValue[];
}

export class QualityMeasure implements QualityMeasureInterface {
  "id": number;
  "name": string;
  "value_ids": Array<any>;
  valueIds: QualityMeasureValue[];
  constructor(data?: QualityMeasureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `QualityMeasure`.
   */
  public static getModelName() {
    return "QualityMeasure";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of QualityMeasure for dynamic purposes.
  **/
  public static factory(data: QualityMeasureInterface): QualityMeasure{
    return new QualityMeasure(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'QualityMeasure',
      plural: 'QualityMeasures',
      path: 'QualityMeasures',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "value_ids": {
          name: 'value_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        valueIds: {
          name: 'valueIds',
          type: 'QualityMeasureValue[]',
          model: 'QualityMeasureValue',
          relationType: 'referencesMany',
                  keyFrom: 'value_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/QualityMeasure.ts